import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';

export const FilterPopperPaper = styled(Paper, { name: 'FilterPopperPaper' })(
  ({ theme }) => ({
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(1),
    padding: theme.spacing(2),
    boxShadow: theme.shadows[4],
  })
);
